// Runtime theming: drive the whole UI accent from a user's saved brand colour.
const DEFAULT_RGB = '194 83 42';

export function hexToRgbChannels(hex) {
  const m = /^#?([0-9a-fA-F]{6})$/.exec((hex || '').trim());
  if (!m) return null;
  const n = parseInt(m[1], 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}

function relLuminance([r, g, b]) {
  const a = [r, g, b].map((v) => {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  });
  return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
}

function darkenHex([r, g, b], amt = 0.14) {
  const f = (v) => Math.max(0, Math.round(v * (1 - amt)));
  const toHex = (v) => f(v).toString(16).padStart(2, '0');
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}

export function applyBrand(hex) {
  const root = document.documentElement;
  const rgb = hexToRgbChannels(hex);
  if (!rgb) { resetBrand(); return; }
  root.style.setProperty('--tm-brand-rgb', rgb.join(' '));
  root.style.setProperty('--tm-brand-ink', relLuminance(rgb) > 0.55 ? '#0F172A' : '#FFFFFF');
  root.style.setProperty('--tm-orange-hover', darkenHex(rgb, 0.14));
}

export function resetBrand() {
  const root = document.documentElement;
  root.style.setProperty('--tm-brand-rgb', DEFAULT_RGB);
  root.style.setProperty('--tm-brand-ink', '#FFFFFF');
  root.style.setProperty('--tm-orange-hover', '#A3431F');
}
